import { render } from "./ModalFinalizacao.vue?vue&type=template&id=71ff89ba"
import script from "./ModalFinalizacao.vue?vue&type=script&lang=js"
export * from "./ModalFinalizacao.vue?vue&type=script&lang=js"

import "./ModalFinalizacao.vue?vue&type=style&index=0&id=71ff89ba&lang=scss"
script.render = render

export default script